export const GET_TOUR_GUIDE = "tour-guide";

export const POST_TOUR_GUIDE = "tour-guide";

//REGISTER
export const POST_REGISTER = "auth/signup";

//LOGIN
export const POST_LOGIN = "auth/login";

//RESEND VERIFICATION EMAIL
export const POST_RESEND_VERIFICATION_EMAIL = "auth/send-verification-email";

//LOGOUT
export const POST_LOGOUT = "auth/logout";

//DELETE ACCOUNT
export const DELETE_ACCOUNT = "user";

//FORGOT PASSWORD
export const POST_PASSWORD_FORGET = "auth/forgot-password";

//PROFILE
export const POST_PROFILE = "user/profile-setup";

//BUSINESS PROFILE SETUP
export const POST_BUSINESS_PROFILE_SETUP = "company";

export const GET_APP_CONFIG = "auth/config";

// Dasboard
export const GET_DASHBOARD = "home";

// Clients
export const GET_CLIENTS = "clients";
export const GET_CLIENT_BY_ID = "clients";
export const ADD_NEW_CLIENT = "clients";
export const UPDATE_CLIENT = "clients";
export const DELETE_CLIENT = "clients";

export const UPDATE_STATUS = "update-status";

// Quotes
export const GET_QUOTES = "quotes";
export const GET_QUOTE_BY_ID = "quotes";
export const ADD_NEW_QUOTE = "quotes";
export const CREATE_QUOTE = "quotes";
export const UPDATE_QUOTE = "quotes";
export const DELETE_QUOTE = "quotes";
export const GENERATE_QUOTE = "quotes";
export const SEND_QUOTE = "quotes";

// Invoices
export const GET_INVOICES = "invoices";
export const GET_INVOICE_BY_ID = "invoices";
export const ADD_NEW_INVOICE = "invoices";
export const CREATE_INVOICE = "invoices";
export const UPDATE_INVOICE = "invoices";
export const DELETE_INVOICE = "invoices";
export const GENERATE_INVOICE = "invoices";
export const SEND_INVOICE_EMAIL = "invoices";

// categories
export const GET_CATEGORIES = "categories";
export const MANAGE_CATEGORY = "categories";
export const DELETE_CATEGORY = "categories";

// sub categories
export const GET_SUBCATEGORIES = "sub-categories";
export const MANAGE_SUBCATEGORY = "sub-categories";
export const DELETE_SUBCATEGORY = "sub-categories";

// items
export const GET_ITEMS = "items";
export const ADD_ITEM = "item/create-or-update";
export const ADD_ITEM_CSV = "items/import";
export const EDIT_ITEM = "item/create-or-update";
export const DELETE_ITEM = "items";

// Settings
export const CHANGE_PWD = "auth/change-password";
export const NOTIFICATION_SETTINGS = "auth/notification_settings";
export const QUOTE_INVOICE_SETTINGS = "auth/quote-invoice-settings";
export const BILLING_PREFERENCES = "auth/billing-preferences";

//Notifications
export const GET_NOTIFICATION = "notifications";

//BILLINGS
export const BILLING_DETAILS = "company/billing-details";
export const MANAGE_BILLING_DETAILS = "company/billing-details";

//SECTION

export const GET_SECTIONS = "proposal-document/sections";
export const DELETE_SECTIONS = "proposal-document/sections";
export const ADD_SECTION = "proposal-document/sections";
export const EDIT_SECTION = "proposal-document/sections";

//Preset Quote
export const GET_PRESET_QUOTES = "quote-templates";
export const POST_PRESET_QUOTES = "quote-templates";
export const DELETE_PRESET_QUOTES = "quote-templates";

//TEAM MEMBERS
export const GET_TEAM_MEMBERS = "company/users";
export const EDIT_TEAM_MEMBER = "company/users";
export const ADD_TEAM_MEMBER = "company/users";

//SUBMIT SUPPORT TICKET
export const SUBMIT_SUPPORT_TICKET = "support-ticket";

//Admin Dashboard Apis
export const ADMIN_HOME = "admin/home";
export const ADMIN_USERS = "users/list";
export const MANAGE_DISABLE_USER = "users";
export const ADMIN_DELETE_USER = "admin-delete-user";

export const GET_USER_DETAIL = "user/detail";
export const IMPERSONATE_INITIATE = "users";
export const IMPERSONATE_LEAVE = "impersonate/leave";

//Billing Info
export const GET_BILLINGS = "billing-history";
export const DOWNLOAD_BILLING_INVOICE = "bill-download";

export const GET_ADDRESS = "address/search?postcode";

export const VIEW_EMAIL_QUOTE = "quote";
export const VIEW_EMAIL_INVOICE = "invoice";
export const EMAIL_UPDATE_STATUS = "update-status/secure";

export const PAYMENT = "payments";
export const DELETE_PAYMENT = "payments";
export const PAYMENT_DETAILS = "payments/deposits";
export const PAYMENT_DEPOSIT_QUOTES = "payment-deposit-quotes";
export const STRIPE_SETUP = "stripe/connect/onboard";
